import React from 'react';
import './App.scss';
import { Link } from "react-router-dom";
import * as Constants from "./helper/Constants"

function NotFound(props) {
    const {
        customText
    } = props;
    return (
        <div className="tile-view fadeIn-1s">
            <div className="not-found-description-container">
                {customText ? customText : "Seite nicht gefunden"} <br/>
                <Link to={Constants.LINK_HOME}>
                    {"Zurück zur Startseite"}
                </Link>
            </div>
        </div>
    );
}

export default NotFound;
